import { ReactNode } from "react"
import { get } from "lodash"

import * as icons from "components/icons"
import { SvgIconProps, SxProps } from "@mui/material"

export interface IConfigIcon {
  icon_comp?: string
  icon_path?: string
  image?: string
}

export interface IconProps {
  iconCompProps?: SvgIconProps
  imageIconProps?: { solidColorFilterId?: string }
}

export type GetIcon = (
  config: IConfigIcon,
  sx?: SxProps,
  iconProps?: IconProps
) => ReactNode | null

export const getIcon: GetIcon = (config = {}, sx = {}, iconProps = {}) => {
  const { iconCompProps = {}, imageIconProps = {} } = iconProps || {}
  const { icon_comp = "", icon_path = null, image = null } = config || {}
  const IconComp = get(icons, icon_comp)

  if (IconComp) return <IconComp {...iconCompProps} sx={sx} />

  if (image)
    return (
      <icons.CustomImageIcon
        className="image-icon"
        {...imageIconProps}
        src={image}
        sx={sx}
      />
    )

  if (icon_path)
    return <icons.CustomIcon {...iconCompProps} path={icon_path} sx={sx} />

  return null
}
